import { FC } from 'react';
import {
  Box,
  Button,
  Container,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import type { TransferSummary } from 'src/services/DataVaultTransfer.service';

interface TransferFooterProps {
  summary: TransferSummary | null;
  onCommit: () => void;
  isCommitting: boolean;
}

const TransferFooter: FC<TransferFooterProps> = ({
  summary,
  onCommit,
  isCommitting,
}) => {
  const total = summary?.total ?? 0;
  const decided = summary?.decided ?? 0;
  const remaining = summary?.remaining ?? 1; // default to 1 so Continue stays disabled until summary loads

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Divider />
      <Container maxWidth="md">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ py: 2 }}
        >
          <Typography variant="body2" color="text.secondary">
            {total} answer{total !== 1 ? 's' : ''} &bull; {decided} decided
            &bull; {remaining} left
          </Typography>
          <Button
            variant="contained"
            color="primary"
            disabled={remaining > 0 || isCommitting}
            onClick={onCommit}
          >
            Continue to your interview
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default TransferFooter;
